"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BCMS = void 0;
var util_1 = require("./util");
var axios_1 = require("axios");
var cache_1 = require("./cache");
var handlers_1 = require("./handlers");
function BCMS(config) {
    var _this = this;
    if (!config.storage) {
        config.storage = {
            prfx: 'bcms',
        };
    }
    var queueable = util_1.Queueable('refreshAccessToken');
    var cacheControl = cache_1.CacheControl();
    var storage = util_1.LocalStorage({
        prfx: config.storage.prfx,
    });
    var accessToken;
    var accessTokenRaw = storage.get('at');
    var handlerManager = {
        user: undefined,
        group: undefined,
        widget: undefined,
        template: undefined,
        language: undefined,
        media: undefined,
        entry: undefined,
        apiKey: undefined,
        apiFunction: undefined,
        status: undefined,
        shim: undefined,
    };
    var userHandler = handlers_1.UserHandler(cacheControl, send, storage, function () {
        clear();
    }, function () {
        return accessToken;
    }, isLoggedIn);
    var socket = handlers_1.SocketHandler(cacheControl, handlerManager, {
        url: config.cms.origin,
        path: '/api/socket/server/',
    }, function () {
        return accessToken;
    });
    var entryHandler = handlers_1.EntryHandler(cacheControl, send, socket);
    var widgetHandler = handlers_1.WidgetHandler(cacheControl, send, entryHandler);
    var templateHandler = handlers_1.TemplateHandler(cacheControl, send);
    var groupHandler = handlers_1.GroupHandler(cacheControl, send, templateHandler, widgetHandler);
    var languageHandler = handlers_1.LanguageHandler(cacheControl, send);
    var mediaHandler = handlers_1.MediaHandler(cacheControl, send, function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, refreshAccessToken()];
                case 1:
                    _a.sent();
                    return [2, accessTokenRaw];
            }
        });
    }); }, config.cms.origin);
    var apiKeyHandler = handlers_1.ApiKeyHandler(cacheControl, send);
    var apiFunctionHandler = handlers_1.FunctionHandler(cacheControl, send);
    var statusHandler = handlers_1.StatusHandler(cacheControl, send);
    var shimHandler = handlers_1.ShimHandler(cacheControl, send, storage, isLoggedIn);
    handlerManager.user = userHandler;
    handlerManager.apiFunction = apiFunctionHandler;
    handlerManager.apiKey = apiKeyHandler;
    handlerManager.entry = entryHandler;
    handlerManager.group = groupHandler;
    handlerManager.language = languageHandler;
    handlerManager.media = mediaHandler;
    handlerManager.template = templateHandler;
    handlerManager.widget = widgetHandler;
    handlerManager.status = statusHandler;
    handlerManager.shim = shimHandler;
    function unpackAccessToken(at) {
        var atParts = at.split('.');
        if (atParts.length === 3) {
            accessToken = {
                header: JSON.parse(util_1.GeneralUtil.b64.decode(atParts[0])),
                payload: JSON.parse(util_1.GeneralUtil.b64.decode(atParts[1])),
                signature: atParts[2],
            };
        }
    }
    function send(conf, doNotInjectAuth) {
        return __awaiter(this, void 0, void 0, function () {
            var loggedIn, response, error_1, err;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!doNotInjectAuth &&
                            conf.headers &&
                            typeof conf.headers.Authorization === 'string')) return [3, 2];
                        return [4, isLoggedIn()];
                    case 1:
                        loggedIn = _a.sent();
                        conf.headers.Authorization = "Bearer " + accessTokenRaw;
                        if (loggedIn === false || !accessTokenRaw) {
                            if (typeof config.loginPath === 'string') {
                                console.error('Go to login page.');
                            }
                            else {
                                throw {
                                    status: 401,
                                    message: 'Not logged in.',
                                };
                            }
                        }
                        _a.label = 2;
                    case 2:
                        if (!conf.headers && socket.id) {
                            conf.headers = {
                                sid: socket.id(),
                            };
                        }
                        else if (socket.id()) {
                            conf.headers.sid = socket.id();
                        }
                        conf.url = config.cms.origin + "/api" + conf.url;
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 5, , 6]);
                        return [4, axios_1.default(conf)];
                    case 4:
                        response = _a.sent();
                        return [2, response.data];
                    case 5:
                        error_1 = _a.sent();
                        err = error_1;
                        if (err.response) {
                            if (err.response.data && err.response.data.message) {
                                throw {
                                    status: err.response.status,
                                    code: err.response.data.code,
                                    message: err.response.data.message,
                                };
                            }
                            else {
                                throw {
                                    status: err.response.status,
                                    code: '-1',
                                    message: err.message,
                                };
                            }
                        }
                        else {
                            throw {
                                status: -1,
                                code: '-1',
                                message: err.message,
                            };
                        }
                        return [3, 6];
                    case 6: return [2];
                }
            });
        });
    }
    function isLoggedIn() {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, refreshAccessToken()];
                    case 1:
                        result = _a.sent();
                        if (!(socket && result === true && !socket.connected())) return [3, 3];
                        return [4, socket.connect(accessTokenRaw, accessToken)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2, result];
                }
            });
        });
    }
    function refreshAccessToken() {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, queueable.exec('refreshAccessToken', 'free_one_by_one', function () { return __awaiter(_this, void 0, void 0, function () {
                            var refresh, at, refreshToken, result, error_2;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        refresh = true;
                                        if (typeof accessToken !== 'undefined') {
                                            if (accessToken.payload.iat + accessToken.payload.exp > Date.now()) {
                                                refresh = false;
                                            }
                                        }
                                        else {
                                            at = storage.get('at');
                                            if (at) {
                                                unpackAccessToken(at);
                                                if (accessToken.payload.iat +
                                                    accessToken.payload.exp >
                                                    Date.now()) {
                                                    refresh = false;
                                                }
                                            }
                                        }
                                        if (refresh === false) {
                                            return [2, true];
                                        }
                                        refreshToken = storage.get('rt');
                                        if (!refreshToken) {
                                            return [2, false];
                                        }
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([1, 4, , 6]);
                                        return [4, send({
                                                url: '/auth/token/refresh',
                                                method: 'POST',
                                                headers: {
                                                    Authorization: "Bearer " + refreshToken,
                                                },
                                            }, true)];
                                    case 2:
                                        result = _a.sent();
                                        return [4, storage.set('at', result.accessToken)];
                                    case 3:
                                        _a.sent();
                                        return [2, true];
                                    case 4:
                                        error_2 = _a.sent();
                                        return [4, storage.clear()];
                                    case 5:
                                        _a.sent();
                                        return [2, false];
                                    case 6: return [2];
                                }
                            });
                        }); })];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    }
    function clear() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                storage.clear();
                cacheControl.clear();
                accessToken = undefined;
                accessTokenRaw = undefined;
                socket.disconnect();
                return [2];
            });
        });
    }
    if (accessTokenRaw) {
        unpackAccessToken(accessTokenRaw);
    }
    storage.subscribe('at', function (value, type) {
        if (type === 'set') {
            accessTokenRaw = value;
            unpackAccessToken(value);
            if (!socket.connected()) {
                socket.connect(value, accessToken);
            }
        }
        else if (type === 'remove') {
            socket.disconnect();
        }
    });
    isLoggedIn().catch(function (error) {
        console.error(error);
    });
    return __assign({ getAccessToken: function () {
            return accessToken;
        },
        isLoggedIn: isLoggedIn,
        send: send, socket: {
            id: socket.id,
            subscribe: function (event, handler) {
                return socket.subscribe(event, handler);
            },
        } }, handlerManager);
}
exports.BCMS = BCMS;
//# sourceMappingURL=sdk.js.map